import { useTranslation } from 'react-i18next';

import { cn } from '@shared/components/ui/cn';
import {
  fileFormatKind,
  fileTileLabel,
  UNKNOWN_FORMAT_LABEL,
  type FileFormatKind,
} from '@shared/lib/file-format';

export type FileFormatTileTone = 'default' | 'unsupported' | 'unavailable';

export interface FileFormatTileProps {
  extension: string;
  tone?: FileFormatTileTone;
  className?: string;
}

const KIND_BACKGROUND: Record<FileFormatKind, string> = {
  pdf: 'bg-[#dc2626]',
  word: 'bg-[#2563eb]',
  excel: 'bg-[#15803d]',
  csv: 'bg-[#0f766e]',
  powerpoint: 'bg-[#c2410c]',
  image: 'bg-[#7c3aed]',
  audio: 'bg-[#be185d]',
  text: 'bg-[#475569]',
  archive: 'bg-[#b45309]',
  other: 'bg-neutral-500',
};

export function FileFormatTile({ extension, tone = 'default', className }: FileFormatTileProps) {
  const { t } = useTranslation('common');
  const tileLabel = fileTileLabel(extension);
  const label =
    tileLabel === UNKNOWN_FORMAT_LABEL
      ? t('fileCard.unknownFormat', UNKNOWN_FORMAT_LABEL)
      : tileLabel;

  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex size-10 shrink-0 items-center justify-center rounded-[10px] font-semibold',
        label.length > 3 ? 'text-xs' : 'text-sm',
        tone === 'unsupported'
          ? 'bg-[#fee2e2] text-[#b91c1c]'
          : [KIND_BACKGROUND[fileFormatKind(extension)], 'text-white'],
        tone === 'unavailable' && 'opacity-50',
        className,
      )}
    >
      {label}
    </span>
  );
}
